import post from '../../core/methods/post'
import { StringNumber } from '../types'
import { GroupInfoRes } from './types'
export type { GroupInfoJoinType, GroupInfoRes, GroupInfoResInfo } from './types'

/**
 * 群信息
 * @description https://api.yinnho.cn/api.php?do=group_info&help
 *
 * @param id 群id
 */
export function group_info (id: StringNumber) {
  return post<GroupInfoRes>('group_info', { id })
}
